import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Button, Drawer, Stack, useMediaQuery } from '@mui/material';
import MiniDrawerStyled from './MiniDrawerStyled';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BrowserView, MobileView } from 'react-device-detect';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import LAYOUT_CONST, { drawerWidth } from 'store/constant';
import { PLAN_TYPE } from 'helper/checkPlan.helper';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { SET_MODAL_STATUS, SET_MODAL_TYPE } from 'store/actions';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, window, drawerType }) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    // const matchUpMd = useMediaQuery(theme.breakpoints.up('lg'));
    const matchUpMd = useMediaQuery(theme.breakpoints.up('lg'));
    const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
    const { companyData } = useSelector((params) => params.customization);
    const { companyCreator } = useSelector((state) => state.authentication);
    const navigate = useNavigate();

    const drawer = (
        <>
            <BrowserView>
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 57px)',
                        padding: '16px'
                        // paddingRight: '16px'
                    }}
                >
                    <Stack className="sidebar-list-wrap" justifyContent={'space-between'} sx={{ height: '100%' }}>
                        <Box className="sidebar-menu">
                            <MenuList drawerOpen={drawerOpen} />
                        </Box>
                        {companyData?.subscription?.plan === PLAN_TYPE.Freemium && (
                            <Button
                                disableRipple
                                variant="outlined"
                                startIcon={<DiamondOutlinedIcon width="24px" />}
                                className={`btn-freemium ${drawerOpen === false ? 'btn-collapse' : ''}`}
                                onClick={() => {
                                    if (!companyCreator) {
                                        dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
                                        dispatch({ type: SET_MODAL_TYPE, modalType: 'non_permit_upgrade' });
                                        return;
                                    } else {
                                        navigate('/dashboard/update-plan');
                                    }
                                }}
                            >
                                Upgrade your plan to premium
                            </Button>
                        )}
                    </Stack>
                </PerfectScrollbar>
            </BrowserView>
            <MobileView>
                {/* <MenuList drawerOpen={drawerOpen} /> */}
                <PerfectScrollbar
                    component="div"
                    style={{
                        height: !matchUpMd ? '100vh' : 'calc(100vh - 57px)',
                        padding: '16px'
                        // paddingRight: '16px'
                    }}
                >
                    <Stack className="sidebar-list-wrap" justifyContent={'space-between'} sx={{ height: '100%' }}>
                        <Box className="sidebar-menu">
                            <MenuList drawerOpen={drawerOpen} />
                        </Box>
                        <Button
                            disableRipple
                            variant="outlined"
                            startIcon={<DiamondOutlinedIcon width="24px" />}
                            className={`btn-freemium ${drawerOpen === false ? 'btn-collapse' : ''}`}
                        >
                            Upgrade your plan to premium
                        </Button>
                    </Stack>
                </PerfectScrollbar>
            </MobileView>
        </>
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    return (
        <Box component="nav" sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }} aria-label="mailbox folders">
            {matchDownMd || (drawerType === LAYOUT_CONST.MINI_DRAWER && drawerOpen) ? (
                <Drawer
                    container={container}
                    variant={matchUpMd ? 'persistent' : 'temporary'}
                    anchor="left"
                    open={drawerOpen}
                    onClose={drawerToggle}
                    elevation={0}
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            background: theme.palette.background.default,
                            color: theme.palette.text.primary,
                            borderRight: 'none',
                            [theme.breakpoints.up('lg')]: {
                                top: '57px'
                            }
                        }
                    }}
                    ModalProps={{ keepMounted: true }}
                    color="inherit"
                    className="dashboard-sidebar"
                >
                    <LogoSection />
                    {drawer}
                </Drawer>
            ) : (
                <MiniDrawerStyled variant="permanent" open={drawerOpen} className="dashboard-sidebar" elevation={0}>
                    {/* <LogoSection /> */}
                    {drawer}
                </MiniDrawerStyled>
            )}
        </Box>
    );
};

export default Sidebar;
